import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=7e71ca86&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Reports.vue"
export default component.exports